import PropTypes from 'prop-types';
import styled from 'styled-components';
import { spacer32 } from '@spotify-internal/encore-foundation';
var TypeList = styled.ul.withConfig({
  displayName: "TypeList",
  componentId: "sc-64lp5j-0"
})(["padding-left:", ";padding-bottom:", ";"], spacer32, function (props) {
  return props.condensed && '0';
});
TypeList.propTypes = {
  condensed: PropTypes.bool
};
TypeList.ul = TypeList.withComponent('ul');
TypeList.ol = TypeList.withComponent('ol');
export default TypeList;